// List filtering/sorting for the Places tab and the Trash.
import { isVisited, lastVisitedDate, wantToTryState } from './visits.js';

// Non-deleted places, filtered by search text / unrated-only, then sorted by `sortBy`. Returns a new array.
export function sortRestaurants(restaurants, { sortBy, query = '', unratedOnly = false, wantFilter = 'none', cuisine = [], vibe = [] } = {}) {
    // Filter out deleted restaurants
    let sorted = restaurants.filter(r => !r.deletedAt);

    // 1. Search/Filter
    if (query.trim()) {
        const q = query.toLowerCase();
        sorted = sorted.filter(r =>
            r.name.toLowerCase().includes(q) ||
            (r.address && r.address.toLowerCase().includes(q)) ||
            (r.notes && r.notes.toLowerCase().includes(q))
        );
    }

    // Filter unrated only
    if (unratedOnly) {
        sorted = sorted.filter(r => typeof r.rating !== 'number');
    }

    // Want-to-try filter: 'mine' = I want it, 'both' = double yes
    if (wantFilter === 'both') sorted = sorted.filter(r => wantToTryState(r) === 'both');
    else if (wantFilter === 'doug' || wantFilter === 'les') sorted = sorted.filter(r => r.wantToTry && r.wantToTry[wantFilter]);

    // Category filters (any selected tag matches)
    if (cuisine.length) sorted = sorted.filter(r => (r.cuisine || []).some(c => cuisine.includes(c)));
    if (vibe.length) sorted = sorted.filter(r => (r.vibe || []).some(v => vibe.includes(v)));

    // 4. Smart Sorting
    if (sortBy === 'rating') {
        sorted.sort((a, b) => {
            if (typeof a.rating !== 'number') return 1;
            if (typeof b.rating !== 'number') return -1;
            return b.rating - a.rating;
        });
    } else if (sortBy === 'recent') {
        sorted.sort((a, b) => (lastVisitedDate(b) || '').localeCompare(lastVisitedDate(a) || ''));
    } else if (sortBy === 'unvisited') {
        sorted.sort((a, b) => {
            const av = isVisited(a), bv = isVisited(b);
            if (!av && bv) return -1;
            if (av && !bv) return 1;
            return a.name.localeCompare(b.name);
        });
    } else if (sortBy === 'topRatedUnvisited') {
        sorted.sort((a, b) => {
            const aUnvisited = !isVisited(a);
            const bUnvisited = !isVisited(b);
            if (aUnvisited && !bUnvisited) return -1;
            if (!aUnvisited && bUnvisited) return 1;
            const aUnrated = typeof a.rating !== 'number';
            const bUnrated = typeof b.rating !== 'number';
            if (aUnrated && bUnrated) return a.name.localeCompare(b.name);
            if (aUnrated) return 1;
            if (bUnrated) return -1;
            return b.rating - a.rating;
        });
    } else if (sortBy === 'favorites') {
        // Show favorites first, then sort by name
        sorted.sort((a, b) => {
            if (a.isFavorite && !b.isFavorite) return -1;
            if (!a.isFavorite && b.isFavorite) return 1;
            return a.name.localeCompare(b.name);
        });
    } else {
        sorted.sort((a, b) => a.name.localeCompare(b.name));
    }

    return sorted;
}

// Trashed places, most recently deleted first
export function deletedRestaurants(restaurants) {
    return restaurants.filter(r => r.deletedAt).sort((a, b) =>
        new Date(b.deletedAt) - new Date(a.deletedAt)
    );
}
